exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide {\n  display: none !important;\n}\ndiv[col-id='checked'] {\n  pointer-events: all !important;\n}\n.camaras .estilo-grilla,\n.camaras #gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.preparacion_equipos .ag-pinned-left-cols-container,\n.preparacion_equipos .ag-header .ag-pinned-left-header,\n.preparacion_equipos .ag-body-horizontal-scroll .ag-horizontal-left-spacer {\n  display: none;\n}\n", ""]);

// exports
